document.addEventListener('DOMContentLoaded', () => {
    const observerOptions = {
        root: null,
        rootMargin: '0px',
        threshold: 0.1
    };

//スライダー
    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
              setTimeout(() => {
                initializeSwiper(entry.target);
                observer.unobserve(entry.target);
              }, 1000);
            }
        });
    }, observerOptions);

    const swiperContainers = [
        '#shopify-section-template--22439366787366__recently-viewed'
    ];

    swiperContainers.forEach(selector => {
        const container = document.querySelector(selector);
        if (container) {
            observer.observe(container);
        }
    });
});

function initializeSwiper(container) {
    let nextButton = container.querySelector('.top-swiper-button-next');
    let prevButton = container.querySelector('.top-swiper-button-prev');
    
    new Swiper(container.querySelector('.top-swiper'), {
        loop: true,
        speed: 500,
        slidesPerView: 'auto',
        centeredSlides: false,
        breakpoints: {
            768: {
                slidesPerView: 4,
            },
        },
        navigation: {
            nextEl: nextButton,
            prevEl: prevButton,
        },
    });
}